import React, { Suspense } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Registration from '../pages/Registration/Registration';
import Login from '../pages/Login/Login';
import Dashboard from '../pages/Dashboard/Dashboard';
import ForgotPassword from '../pages/ForgotPassword/ForgotPassword';
import TutionFeeChalanForm from '../pages/Dashboard/Contents/ChalanForms/TutionFeeChalanForm';
import AdmissionFormAlevel from '../pages/Dashboard/Contents/AdmissionFormAlevel/AdmissionFormAlevel';
import PrivateRoutes from './PrivateRoutes';

const NoMatchPage = () => {
    return (
        <Navigate to="/login" />
    );
};

const CheckLogin = () => {
    const uclToken = localStorage.getItem('uclToken');
    if (uclToken) {
        return (
            <Navigate to="/dashboard" />
        );
    } else {
        return (
            <Login />
        );
    }
}

const AppRoute = () => {

    return (
        <>
            <Router>
                <Suspense fallback={<p>Loading...</p>}>
                    <Routes>
                        <Route path="/login" element={<CheckLogin />} />
                        <Route path="/registration" element={<Registration />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/apply-alevel" element={<AdmissionFormAlevel />} />

                        <Route element={<PrivateRoutes />}>
                            <Route path="/dashboard/*" element={<Dashboard />} />
                            <Route path="/challan-view" element={<TutionFeeChalanForm />} />
                        </Route>

                        <Route path="*" element={<NoMatchPage />} />
                    </Routes>
                </Suspense>
            </Router>
        </>
    );
}

export default AppRoute;
